export default () => {

  $('.js-find-community-form').map((index, el) => {

    const $input = $(el).find('input');
    const inputNode = $input[0];
    const $button = $(el).find('button');

    const autocomplete = new google.maps.places.Autocomplete(inputNode, {
      componentRestrictions: {
        country: 'us'
      }
    });

    $input
      // Disable/enable address search Go button depending on if field has value or not
      .on('input', () => {
        if ($input.val()) {
          $button.attr('disabled', false);
        } else {
          $button.attr('disabled', true);
        }
      })
      // Trigger search when enter key is pressed
      .on('keypress', (e) => {
        if (e.keyCode === 13 && $button.attr('disabled') !== 'disabled') {
          $button.trigger('click');
        }
      })
    ;

    // Set localStorage for address search and re-direct to find community page
    $button.on('click', () => {
      if (typeof (Storage) !== 'undefined') {
        localStorage.setItem('communitiesPlace', JSON.stringify(autocomplete.getPlace()));
        localStorage.setItem('communitiesAddress', $input.val());
        window.location.href = $button.data('redirect');
      }
    });

  });

};
